import { OverlayControllerModule } from './overlay.controller';

export const OverlayServiceModule = angular
    .module('app.components.overlay.overlayService', [
        'ngMaterial',
        OverlayControllerModule
    ]).service('overlayService', ($mdDialog, $document) => {
        let overlayBodyClass = 'overlay-open';

        function show(config) {
            return $mdDialog.show({
                controller: 'OverlayController',
                template: buildOverlayTemplate(
                    config.controller, config.templateUrl, config.template, config.displayCloseButton
                ),
                parent: angular.element($document.body),
                targetEvent: config.event,
                clickOutsideToClose: false,
                fullscreen: true,
                hasBackdrop: false,
                onShowing: addBodyClass,
                onRemoving: () => {
                    handleRemoving(config.onRemoving);
                }
            });
        }

        function buildOverlayTemplate(controller, templateUrl, template, displayCloseButton = true) {
            return `
                <md-dialog class="overlay">
                    <header class="overlay__header">
                        <logo logo-size="small"></logo>
                            ${displayCloseButton ? `
                            <md-button
                                class="overlay__close md-icon-button"
                                ng-click="close()"
                                ng-if="closeButtonVisible">
                                <md-icon>close</md-icon>
                            </md-button>` : ''}
                    </header>
                    ${template ? `
                        <div
                            class="overlay__content">
                            ${template}
                        </div>` : `
                        <div
                            class="overlay__content"
                            ng-include="'${templateUrl}'"
                            ng-controller="${controller}">
                        </div>
                    `}
                </md-dialog>
            `;
        }

        function addBodyClass() {
            angular.element($document[0].body).addClass(overlayBodyClass);
        }

        function handleRemoving(onRemoving) {
            removeBodyClass();
            if (onRemoving) {
                onRemoving();
            }
        }

        function removeBodyClass() {
            angular.element($document[0].body).removeClass(overlayBodyClass);
        }

        return {
            show
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/overlay/overlay.service.js